import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/scroll-to-top/scroll-to-top';
import Home from './pages/home/home';

const About = lazy(() => import('./pages/about/about'));
const Sectors = lazy(() => import('./pages/sectors/sectors'));
const Projects = lazy(() => import('./pages/projects/projects-v7'));
const Products = lazy(() => import('./pages/products/products'));
const Event = lazy(() => import('./pages/events/event'));
const Career = lazy(() => import('./pages/career/career'));
const Contact = lazy(() => import('./pages/contact/contact'));
const Projectsv1 = lazy(() => import('./pages/projects/projects-v1'));
const Projectsv2 = lazy(() => import('./pages/projects/projects-v2'));
const Projectsv3 = lazy(() => import('./pages/projects/projects-v3'));
const Projectsv4 = lazy(() => import('./pages/projects/projects-v4'));
const Projectsv5 = lazy(() => import('./pages/projects/projects-v5'));
const Projectsv6 = lazy(() => import('./pages/projects/projects-v6'));
const Projectsv7 = lazy(() => import('./pages/projects/projects'));
const Fabrisorb = lazy(() => import('./pages/fabrisorb/fabrisorb'));
const FabrisorbDeco = lazy(() => import('./pages/fabrisorb-deco/fabrisorb-deco'));
const Fabriwall = lazy(() => import('./pages/fabriwall/fabriwall'));
const Decopanel = lazy(() => import('./pages/decopanel/decopanel'));
const Petpanel = lazy(() => import('./pages/pet-panel/pet-panel'));
const Woodtec = lazy(() => import('./pages/woodtec/woodtec'));
const Woodteclinear = lazy(() => import('./pages/woodtec/woodtec-linear-acoustic-panel'));
const Woodtecperforated = lazy(() => import('./pages/woodtec/woodtec-perforated-acoustic-panel'));
const Woodtecslotted = lazy(() => import('./pages/woodtec/woodtec-slotted-acoustic-panel'));
const Woodtecdesigner = lazy(() => import('./pages/woodtec/woodtec-designer-acoustic-panel'));
const Echoeliminator = lazy(() => import('./pages/echo-eliminator/echo-eliminator'));
const Vinylbarrier = lazy(() => import('./pages/vinyl-barrier/vinyl-barrier'));
const Ecotherm = lazy(() => import('./pages/eco-therm/eco-therm'));
const Decowood = lazy(() => import('./pages/deco-wood/deco-wood'));
const Acousticdoors = lazy(() => import('./pages/acoustic-doors/acoustic-doors'));
const Pufoam = lazy(() => import('./pages/pu-foam/pu-foam'));
const Diffuso = lazy(() => import('./pages/diffuso/diffuso'));
const Polymax = lazy(() => import('./pages/polymax/polymax'));
const Polysorb = lazy(() => import('./pages/polysorb/polysorb'));
const Polysorbdeco = lazy(() => import('./pages/polysorb-deco/polysorb-deco'));
const Decobaffles = lazy(() => import('./pages/decopanel/decopanel-baffles-clouds'));
const Decogrooved = lazy(() => import('./pages/decopanel/decopanel-grooved-design'));
const Decoplain = lazy(() => import('./pages/decopanel/decopanel-plain-colors'));
const Decorolls = lazy(() => import('./pages/decopanel/decopanel-plain-print-rolls'));
const Decodesign = lazy(() => import('./pages/decopanel/decopanel-print-design'));
const Decotiles = lazy(() => import('./pages/decopanel/decopanel-tiles'));
const Fabribaffles = lazy(() => import('./pages/fabrisorb/fabrisorb-acoustic-baffles'));
const Fabriclouds = lazy(() => import('./pages/fabrisorb/fabrisorb-acoustic-clouds'));
const Fabridesign = lazy(() => import('./pages/fabrisorb/fabrisorb-acoustic-designer-panels'));
const Fabrisorbwall = lazy(() => import('./pages/fabrisorb/fabrisorb-acoustic-wall-panels'));
const Fabrifabric = lazy(() => import('./pages/fabriwall/fabriwall-fabric'));
const Fabripanel = lazy(() => import('./pages/fabriwall/fabriwall-panel'));
const Fabritrack = lazy(() => import('./pages/fabriwall/fabriwall-track'));
const Polyceiling = lazy(() => import('./pages/polysorb/polysorb-ceiling-panels'));
const Polydesign = lazy(() => import('./pages/polysorb/polysorb-designer-panels'));
const Polywall = lazy(() => import('./pages/polysorb/polysorb-acoustic-wall-panels'));
const Polybaffles = lazy(() => import('./pages/polysorb/polysorb-ceiling-baffles'));
const Putrap = lazy(() => import('./pages/pu-foam/pu-foam-bass-trap-design'));
const Pucylind = lazy(() => import('./pages/pu-foam/pu-foam-cylindrical-panels'));
const Puegg = lazy(() => import('./pages/pu-foam/pu-foam-eggcrate-design'));
const Puflat = lazy(() => import('./pages/pu-foam/pu-foam-flat-design'));
const Pupyramid = lazy(() => import('./pages/pu-foam/pu-foam-pyramid-design'));
const Acousticwall = lazy(() => import('./pages/sectors/acoustic-wall'));
const Architectural = lazy(() => import('./pages/sectors/architectural-acoustics'));
const Auditorium = lazy(() => import('./pages/sectors/auditorium-acoustics'));
const Commercial = lazy(() => import('./pages/sectors/commercial-acoustics.js'));
const Education = lazy(() => import('./pages/sectors/education-acoustics'));
const Entertainment = lazy(() => import('./pages/sectors/entertainment-acoustics'));
const Homecinema = lazy(() => import('./pages/sectors/homecinema-acoustics'));
const Hospitality = lazy(() => import('./pages/sectors/hospitality-acoustics'));
const Industrial = lazy(() => import('./pages/sectors/industrial-acoustics'));
const Seating = lazy(() => import('./pages/sectors/seating-solutions'));
const Studio = lazy(() => import('./pages/sectors/studio-acoustics'));
const Themepark = lazy(() => import('./pages/sectors/themepark-acoustics'));
const Africahall = lazy(() => import('./pages/projects/africa-hall-acoustics'));
const Americanschool = lazy(() => import('./pages/projects/american-school-acoustics'));
const Portauthority = lazy(() => import('./pages/projects/auditorium-port-authority-acoustics'));
const Azamtv = lazy(() => import('./pages/projects/azam-tv-acoustics'));
const Beeah = lazy(() => import('./pages/projects/beeah-acoustics'));
const Dancefm = lazy(() => import('./pages/projects/dance-fm-acoustics'));
const Dubaiairport = lazy(() => import('./pages/projects/dubai-airport-acoustics'));
const Dubaipark = lazy(() => import('./pages/projects/dubai-park-acoustics'));
const Eibfs = lazy(() => import('./pages/projects/eibfs-acoustics'));
const Emal = lazy(() => import('./pages/projects/emal-acoustics'));
const Emarati = lazy(() => import('./pages/projects/emarati-school-acoustics'));
const Etisalat = lazy(() => import('./pages/projects/etisalat-auditorium-acoustics'));
const Ferrari = lazy(() => import('./pages/projects/ferrari-world-acoustics'));
const Fujairah = lazy(() => import('./pages/projects/fujairah-auditorium-acoustics'));
const Hilton = lazy(() => import('./pages/projects/hilton-hotel-acoustics'));
const Kalbatv = lazy(() => import('./pages/projects/kalba-tv-acoustics'));
const Kapsarc = lazy(() => import('./pages/projects/kapsarc-acoustics'));
const Khalifa = lazy(() => import('./pages/projects/khalifa-university-acoustics'));
const Louvre = lazy(() => import('./pages/projects/louvre-acoustics'));
const Museum = lazy(() => import('./pages/projects/museum-of-the-future-acoustics'));
const Nationalbank = lazy(() => import('./pages/projects/national-bank-acoustics'));
const Novocinemas = lazy(() => import('./pages/projects/novo-cinemas-acoustics'));
const Novopark = lazy(() => import('./pages/projects/novo-park-acoustics'));
const Orbi = lazy(() => import('./pages/projects/orbi-theatre-acoustics'));
const Presidential = lazy(() => import('./pages/projects/presidential-palace-acoustics'));
const Primaryschool = lazy(() => import('./pages/projects/primary-schools-acoustics'));
const Privatehome = lazy(() => import('./pages/projects/private-home-cinema-acoustics'));
const Rashid = lazy(() => import('./pages/projects/rashid-library-acoustics'));
const Skynews = lazy(() => import('./pages/projects/skynews-acoustics'));
const Sportscomplex = lazy(() => import('./pages/projects/sports-complex-acoustics'));
const Thumbay = lazy(() => import('./pages/projects/thumbay-group-acoustics'));
const Utc = lazy(() => import('./pages/projects/utc-aerospace-systems-acoustics'));
const Voxcinema = lazy(() => import('./pages/projects/vox-cinema-acoustics'));
const Whotel = lazy(() => import('./pages/projects/w-hotel-acoustics'));
const Search = lazy(() => import('./pages/search/search'));
const Abudhabi = lazy(() => import('./pages/abu-dhabi/abu-dhabi'));
const Bahrain = lazy(() => import('./pages/bahrain/bahrain'));
const Dubai = lazy(() => import('./pages/dubai/dubai'));
const Kuwait = lazy(() => import('./pages/kuwait/kuwait'));
const Oman = lazy(() => import('./pages/oman/oman'));
const Qatar = lazy(() => import('./pages/qatar/qatar'));
const Saudiarabia = lazy(() => import('./pages/saudi-arabia/saudi-arabia'));
const Sharjah = lazy(() => import('./pages/sharjah/sharjah'));
const GemsFounderScl = lazy(() => import('./pages/projects/gems-founders-scl.js'));
const Mandir = lazy(() => import('./pages/projects/mandir.js'));
const FirstAbudhabiBank = lazy(() => import('./pages/projects/first-abudhabi-bank.js'));
const GurmVilla = lazy(() => import('./pages/projects/project-ai-gurm-villa.js'));
const Icesco = lazy(() => import('./pages/projects/project-icesco.js'));

function App() {
  return (
    <div className='App'>
      <Router>
        <ScrollToTop>
          <Suspense
            fallback={
              <div
                style={{
                  height: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                Loading...
              </div>
            }
          >
            <Routes>
              <Route exact path='/' element={<Home />} />
              <Route exact path='/about' element={<About />} />
              <Route exact path='/sectors' element={<Sectors />} />
              <Route exact path='/projects' element={<Projects />} />
              <Route exact path='/products' element={<Products />} />
              <Route exact path='/event' element={<Event />} />
              <Route exact path='/career' element={<Career />} />
              <Route exact path='/contact' element={<Contact />} />
              <Route exact path='/projects-v1' element={<Projectsv1 />} />
              <Route exact path='/projects-v2' element={<Projectsv2 />} />
              <Route exact path='/projects-v3' element={<Projectsv3 />} />
              <Route exact path='/projects-v4' element={<Projectsv4 />} />
              <Route exact path='/projects-v5' element={<Projectsv5 />} />
              <Route exact path='/projects-v6' element={<Projectsv6 />} />
              <Route exact path='/projects-v7' element={<Projectsv7 />} />
              <Route exact path='/fabrisorb' element={<Fabrisorb />} />
              <Route exact path='/fabrisorb-deco' element={<FabrisorbDeco />} />
              <Route exact path='/fabriwall' element={<Fabriwall />} />
              <Route exact path='/decopanel' element={<Decopanel />} />
              <Route exact path='/pet-panel' element={<Petpanel />} />
              <Route exact path='/woodtec' element={<Woodtec />} />
              <Route exact path='/woodtec-linear-acoustic-panel' element={<Woodteclinear />} />
              <Route exact path='/woodtec-perforated-acoustic-panel' element={<Woodtecperforated />} />
              <Route exact path='/woodtec-slotted-acoustic-panel' element={<Woodtecslotted />} />
              <Route exact path='/woodtec-designer-acoustic-panel' element={<Woodtecdesigner />} />
              <Route exact path='/echo-eliminator' element={<Echoeliminator />} />
              <Route exact path='/vinyl-barrier' element={<Vinylbarrier />} />
              <Route exact path='/eco-therm' element={<Ecotherm />} />
              <Route exact path='/deco-wood' element={<Decowood />} />
              <Route exact path='/acoustic-doors' element={<Acousticdoors />} />
              <Route exact path='/pu-foam' element={<Pufoam />} />
              <Route exact path='/diffuso' element={<Diffuso />} />
              <Route exact path='/polymax' element={<Polymax />} />
              <Route exact path='/polysorb' element={<Polysorb />} />
              <Route exact path='/polysorb-deco' element={<Polysorbdeco />} />
              <Route exact path='/decopanel-baffles-clouds' element={<Decobaffles />} />
              <Route exact path='/decopanel-grooved-design' element={<Decogrooved />} />
              <Route exact path='/decopanel-plain-colors' element={<Decoplain />} />
              <Route exact path='/decopanel-plain-print-rolls' element={<Decorolls />} />
              <Route exact path='/decopanel-print-design' element={<Decodesign />} />
              <Route exact path='/decopanel-tiles' element={<Decotiles />} />
              <Route exact path='/fabrisorb-acoustic-baffles' element={<Fabribaffles />} />
              <Route exact path='/fabrisorb-acoustic-clouds' element={<Fabriclouds />} />
              <Route exact path='/fabrisorb-acoustic-designer-panels' element={<Fabridesign />} />
              <Route exact path='/fabrisorb-acoustic-wall-panels' element={<Fabrisorbwall />} />
              <Route exact path='/fabriwall-fabric' element={<Fabrifabric />} />
              <Route exact path='/fabriwall-panel' element={<Fabripanel />} />
              <Route exact path='/fabriwall-track' element={<Fabritrack />} />
              <Route exact path='/polysorb-ceiling-panels' element={<Polyceiling />} />
              <Route exact path='/polysorb-designer-panels' element={<Polydesign />} />
              <Route exact path='/polysorb-acoustic-wall-panels' element={<Polywall />} />
              <Route exact path='/polysorb-ceiling-baffles' element={<Polybaffles />} />
              <Route exact path='/pu-foam-bass-trap-design' element={<Putrap />} />
              <Route exact path='/pu-foam-cylindrical-panels' element={<Pucylind />} />
              <Route exact path='/pu-foam-eggcrate-design' element={<Puegg />} />
              <Route exact path='/pu-foam-flat-design' element={<Puflat />} />
              <Route exact path='/pu-foam-pyramid-design' element={<Pupyramid />} />
              <Route exact path='/acoustic-wall' element={<Acousticwall />} />
              <Route exact path='/architectural-acoustics' element={<Architectural />} />
              <Route exact path='/auditorium-acoustics' element={<Auditorium />} />
              <Route exact path='/commercial-acoustics' element={<Commercial />} />
              <Route exact path='/education-acoustics' element={<Education />} />
              <Route exact path='/entertainment-acoustics' element={<Entertainment />} />
              <Route exact path='/homecinema-acoustics' element={<Homecinema />} />
              <Route exact path='/hospitality-acoustics' element={<Hospitality />} />
              <Route exact path='/industrial-acoustics' element={<Industrial />} />
              <Route exact path='/seating-solutions' element={<Seating />} />
              <Route exact path='/studio-acoustics' element={<Studio />} />
              <Route exact path='/themepark-acoustics' element={<Themepark />} />
              <Route exact path='/africa-hall-acoustics' element={<Africahall />} />
              <Route exact path='/american-school-acoustics' element={<Americanschool />} />
              <Route exact path='/auditorium-port-authority-acoustics' element={<Portauthority />} />
              <Route exact path='/azam-tv-acoustics' element={<Azamtv />} />
              <Route exact path='/beeah-acoustics' element={<Beeah />} />
              <Route exact path='/dance-fm-acoustics' element={<Dancefm />} />
              <Route exact path='/dubai-airport-acoustics' element={<Dubaiairport />} />
              <Route exact path='/dubai-park-acoustics' element={<Dubaipark />} />
              <Route exact path='/eibfs-acoustics' element={<Eibfs />} />
              <Route exact path='/emal-acoustics' element={<Emal />} />
              <Route exact path='/emarati-school-acoustics' element={<Emarati />} />
              <Route exact path='/gems-founders-scl' element={<GemsFounderScl />} />
              <Route exact path='/mandir' element={<Mandir />} />
              <Route exact path='/etisalat-auditorium-acoustics' element={<Etisalat />} />
              <Route exact path='/ferrari-world-acoustics' element={<Ferrari />} />
              <Route exact path='/fujairah-auditorium-acoustics' element={<Fujairah />} />
              <Route exact path='/hilton-hotel-acoustics' element={<Hilton />} />
              <Route exact path='/kalba-tv-acoustics' element={<Kalbatv />} />
              <Route exact path='/kapsarc-acoustics' element={<Kapsarc />} />
              <Route exact path='/khalifa-university-acoustics' element={<Khalifa />} />
              <Route exact path='/louvre-acoustics' element={<Louvre />} />
              <Route exact path='/museum-of-the-future-acoustics' element={<Museum />} />
              <Route exact path='/national-bank-acoustics' element={<Nationalbank />} />
              <Route exact path='/novo-cinemas-acoustics' element={<Novocinemas />} />
              <Route exact path='/novo-park-acoustics' element={<Novopark />} />
              <Route exact path='/orbi-theatre-acoustics' element={<Orbi />} />
              <Route exact path='/Abudhabi-bank' element={<FirstAbudhabiBank />} />
              <Route exact path='/gurm-villa' element={<GurmVilla />} />
              <Route exact path='/project-icesco' element={<Icesco />} />
              <Route exact path='/presidential-palace-acoustics' element={<Presidential />} />
              <Route exact path='/primary-schools-acoustics' element={<Primaryschool />} />
              <Route exact path='/private-home-cinema-acoustics' element={<Privatehome />} />
              <Route exact path='/rashid-library-acoustics' element={<Rashid />} />
              <Route exact path='/skynews-acoustics' element={<Skynews />} />
              <Route exact path='/sports-complex-acoustics' element={<Sportscomplex />} />
              <Route exact path='/thumbay-group-acoustics' element={<Thumbay />} />
              <Route exact path='/utc-aerospace-systems-acoustics' element={<Utc />} />
              <Route exact path='/vox-cinema-acoustics' element={<Voxcinema />} />
              <Route exact path='/w-hotel-acoustics' element={<Whotel />} />
              <Route exact path='/search' element={<Search />} />
              <Route exact path='/abu-dhabi' element={<Abudhabi />} />
              <Route exact path='/bahrain' element={<Bahrain />} />
              <Route exact path='/dubai' element={<Dubai />} />
              <Route exact path='/kuwait' element={<Kuwait />} />
              <Route exact path='/oman' element={<Oman />} />
              <Route exact path='/qatar' element={<Qatar />} />
              <Route exact path='/saudi-arabia' element={<Saudiarabia />} />
              <Route exact path='/sharjah' element={<Sharjah />} />
            </Routes>
          </Suspense>
        </ScrollToTop>
      </Router>
    </div>
  );
}

export default App;
